(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ruv-tabs]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const tabs = [...group.querySelectorAll('[role="tab"]')];
      const activate = tab => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(tabs[next]); tabs[next].focus(); }
        });
      });
    });
  };
  const initialize = () => {
    init();
    const main = document.querySelector('.ruv-pdp-main');
    const sticky = document.querySelector('[data-ruv-sticky]');
    if (!main || !sticky) return;
    const buy = sticky.querySelector('[data-ruv-sticky-buy]');
    const sync = () => {
      const submit = main.querySelector('.product-form__submit');
      const price = main.querySelector('[id^="price-"] .price-item--sale')?.closest('.price--on-sale')?.querySelector('.price-item--sale') || main.querySelector('[id^="price-"] .price-item--regular');
      if (price) sticky.querySelector('[data-ruv-sticky-price]').textContent = price.textContent.trim();
      const unavailable = !submit || submit.disabled;
      buy.textContent = unavailable ? 'See availability ↑' : (main.querySelector('variant-selects') ? 'Choose your options ↑' : 'Add to cart ↑');
    };
    buy.addEventListener('click', () => {
      const submit = main.querySelector('.product-form__submit');
      if (!main.querySelector('variant-selects') && submit && !submit.disabled) { submit.click(); return; }
      const target = main.querySelector('variant-selects') || main.querySelector('[data-ruv-purchase]') || main;
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      const focus = target.querySelector('input:not([type="hidden"]),button,select') || main.querySelector('.product-form__submit');
      if (focus) focus.focus({ preventScroll: true });
    });
    const update = () => {
      const purchase = main.querySelector('[data-ruv-purchase]') || main;
      const rect = purchase.getBoundingClientRect();
      const visible = rect.top < innerHeight && rect.bottom > 0;
      sticky.hidden = visible || (innerWidth >= 750 && rect.top > 0);
      sticky.inert = sticky.hidden;
      sticky.setAttribute('aria-hidden', String(sticky.hidden));
    };
    new MutationObserver(() => { sync(); update(); init(main); }).observe(main, { childList: true, subtree: true });
    addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update, { passive: true });
    document.querySelector('cart-drawer')?.addEventListener('transitionend', () => { if (document.querySelector('cart-drawer.active')) sticky.hidden = true; });
    sync(); update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
